export default "__VITE_ASSET__6TiACiW9CqVWRVif5UQhwg__";